import React, { useState, useEffect } from 'react';
import LandingPage from './pages/landing-page/LandingPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import Disclosures from './pages/Disclosures';

function App() {
  const [currentPage, setCurrentPage] = useState(() => {
    return window.location.hash.slice(1) || '/';
  });

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentPage(window.location.hash.slice(1) || '/');
      // Scroll to top when page changes
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  // Scroll to top on initial load if not on landing page
  useEffect(() => {
    if (currentPage !== '/' && currentPage !== '') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [currentPage]);

  // Render appropriate page based on hash
  switch (currentPage) {
    case '/privacy-policy':
      return <PrivacyPolicy />;
    case '/terms-conditions':
      return <TermsConditions />;
    case '/disclosures':
      return <Disclosures />;
    case '/':
    default:
      return <LandingPage />;
  }
}

export default App;
